import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface ConsoleUser { id: string; email: string; role?: 'merchant' | 'support' | 'staff' | 'superadmin'; }
export interface ConsoleStore {
  id: string; externalDomain: string; platform: 'shopify' | 'wordpress' | 'standard' | string;
  planTier: string; subscriptionStatus: string; trialEndsAt: string | null; billingProvider: string;
}

export function isPlatformManagedStore(store: ConsoleStore | null | undefined) {
  const platform = (store?.platform || '').toLowerCase();
  return platform === 'shopify' || platform === 'wordpress';
}

export function getStorePlatformLabel(store: ConsoleStore | null | undefined) {
  const platform = (store?.platform || '').toLowerCase();
  if (platform === 'shopify') return 'Shopify';
  if (platform === 'wordpress') return 'WordPress';
  if (platform === 'standard' || platform === 'site' || platform === 'custom') return 'Standard site';
  return store?.platform ? store.platform : 'Standard site';
}

interface State {
  user: ConsoleUser | null;
  stores: ConsoleStore[];
  activeStoreId: string | null;
  setUser: (u: ConsoleUser | null) => void;
  setStores: (s: ConsoleStore[]) => void;
  setActiveStoreId: (id: string | null) => void;
  logout: () => void;
}

export const useConsoleStore = create<State>()(persist(
  (set) => ({
    user: null, stores: [], activeStoreId: null,
    setUser: (user) => set({ user }),
    setStores: (stores) => set({ stores }),
    setActiveStoreId: (id) => set({ activeStoreId: id }),
    logout: () => set({ user: null, stores: [], activeStoreId: null }),
  }),
  { name: 'reach-console', partialize: (s) => ({ activeStoreId: s.activeStoreId }) },
));

export const useActiveStore = () => {
  const { stores, activeStoreId } = useConsoleStore();
  return stores.find(s => s.id === activeStoreId) ?? null;
};
